import SocialAppContainer from "../../components/applications/socialApp";

const SocialApp = () => {
  return <SocialAppContainer />;
};

export default SocialApp;
